import { Maybe } from '@adornis/base/utilTypes';
import * as jose from 'jose';
import Cookies from 'js-cookie';
import { WTGUser } from './../db/wtg-user';

const host = window.location.host.split('.').slice(-2).join('.');

export async function updateNodeBBCookie() {
  let user: Maybe<WTGUser> = await WTGUser.currentUser.result;

  if (!user) return Cookies.remove('token', { domain: host });

  let data = {
    id: user?._id,
    groups: user.hasVerifiedUniversityMembership ? ['verified'] : [],
    username: user?.username,
    email: user?.email,
  };
  const secret = new TextEncoder().encode('uF/tz$c7lFUQ,=');
  const jwt = await new jose.SignJWT(data)
    .setProtectedHeader({ alg: 'HS256' })
    .setIssuedAt()
    .setExpirationTime('14d')
    .sign(secret);

  Cookies.set('token', jwt, { domain: host });
}
